// hooks/useRedirectIfNotLoggedIn.js

import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { storePostLoginRedirectPath } from "./Utilities"

const useCheckLoggedin = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const { pathname, search } = location;
  
  useEffect(() => {
    if (!user.email) {
      storePostLoginRedirectPath(pathname + search);
      navigate("/auth/login"); // Redirect to login if no user data is found
    }
  }, [user, navigate, location]);
};

export default useCheckLoggedin;
